/*
Copyright 2024 Adobe. All rights reserved.
This file is licensed to you under the Apache License, Version 2.0 (the "License");
you may not use this file except in compliance with the License. You may obtain a copy
of the License at http://www.apache.org/licenses/LICENSE-2.0

Unless required by applicable law or agreed to in writing, software distributed under
the License is distributed on an "AS IS" BASIS, WITHOUT WARRANTIES OR REPRESENTATIONS
OF ANY KIND, either express or implied. See the License for the specific language
governing permissions and limitations under the License.
*/

import { tag as html, TemplateResult } from '../custom-tag.js';

export { setCustomTemplateLiteralTag } from '../custom-tag.js';
export const WorkflowIcon = ({ width = 24, height = 24, hidden = false, title = 'Workflow' } = {}):
  | string
  | TemplateResult => {
  return html`<svg
    xmlns="http://www.w3.org/2000/svg"
    height="${height}"
    viewBox="0 0 36 36"
    width="${width}"
    aria-hidden=${hidden ? 'true' : 'false'}
    role="img"
    fill="currentColor"
    aria-label="${title}"
  >
    <rect height="11.2" rx="1" ry="1" width="8" x="2" y="12" />
    <rect height="6" rx="1" ry="1" width="6" x="28" y="4" />
    <rect height="6" rx="1" ry="1" width="6" x="28" y="14" />
    <rect height="6" rx="1" ry="1" width="6" x="28" y="24" />
    <path
      d="M26 7.5v-1a.5.5 0 0 0-.5-.5h-7a.5.5 0 0 0-.5.5V16h-5.5a.5.5 0 0 0-.5.5v1a.5.5 0 0 0 .5.5H18v9.5a.5.5 0 0 0 .5.5h7a.5.5 0 0 0 .5-.5v-1a.5.5 0 0 0-.5-.5H20v-8h5.5a.5.5 0 0 0 .5-.5v-1a.5.5 0 0 0-.5-.5H20V8h5.5a.5.5 0 0 0 .5-.5Z"
    />
  </svg>`;
};
